import { useCallback, useState } from "react";
import {
	addSection as addSectionHelper,
	duplicateSection as duplicateSectionHelper,
	moveSection as moveSectionHelper,
	removeSection as removeSectionHelper,
	updateSection as updateSectionHelper,
} from "../utils/proposalHelpers";

/**
 * useVisualBuilder - Hook to manage proposal/template blocks and items
 */
export const useVisualBuilder = (initialSections = [], initialItems = []) => {
	const [sections, setSections] = useState(initialSections);
	const [selectedItems, setSelectedItems] = useState(initialItems);

	// Section Actions
	const addSection = useCallback((newSection) => {
		setSections((prev) => addSectionHelper(prev, newSection));
	}, []);

	const removeSection = useCallback((idx) => {
		setSections((prev) => removeSectionHelper(prev, idx));
	}, []);

	const moveSection = useCallback((from, to) => {
		setSections((prev) => moveSectionHelper(prev, from, to));
	}, []);

	const duplicateSection = useCallback((idx) => {
		setSections((prev) => duplicateSectionHelper(prev, idx));
	}, []);

	const updateSection = useCallback((idx, field, value) => {
		setSections((prev) => updateSectionHelper(prev, idx, field, value));
	}, []);

	// Item Actions
	const addItem = useCallback((item) => {
		setSelectedItems((prev) => [
			...prev,
			{ ...item, quantity: item.quantity || 1 },
		]);
	}, []);

	const removeItem = useCallback((idx) => {
		setSelectedItems((prev) => prev.filter((_, i) => i !== idx));
	}, []);

	const updateItem = useCallback((idx, field, value) => {
		setSelectedItems((prev) => {
			const newItems = [...prev];
			newItems[idx] = { ...newItems[idx], [field]: value };
			return newItems;
		});
	}, []);

	const setAllSections = useCallback((newSections) => {
		setSections(newSections);
	}, []);

	const setAllItems = useCallback((newItems) => {
		setSelectedItems(newItems);
	}, []);

	return {
		sections,
		selectedItems,
		addSection,
		removeSection,
		moveSection,
		duplicateSection,
		updateSection,
		addItem,
		removeItem,
		updateItem,
		setAllSections,
		setAllItems,
		totalValue: selectedItems.reduce(
			(sum, item) => sum + parseFloat(item.value || 0) * (item.quantity || 1),
			0,
		),
	};
};
